import { useState } from "react";

import { Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { setMessage, useMaterialUIController } from "context";
import { resetPasswordUser } from "services/users";

// Resetar a senha do usuário e reenviar nova senha no email do atleta
export default function ResetarSenha({
  userId,
}: {
  userId: string;
}): JSX.Element {
  const [, dispatch] = useMaterialUIController();
  const [confirmedReset, setConfirmedReset] = useState(false);

  const handleResetarSenha = async () => {
    try {
      await resetPasswordUser(userId).then(({ message }) => {
        setMessage(dispatch, {
          open: true,
          severity: "success",
          text: message,
        });
        setConfirmedReset(!confirmedReset);
      });
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        severity: "error",
        text: error.message || "Erro ao resetar senha",
      });
    }
  };

  return (
    <>
      {confirmedReset ? (
        <MDBox display="flex" flexDirection="row" alignItems="center" gap={1}>
          <Typography variant="caption">Deseja resetar a senha?</Typography>
          <MDButton
            variant="outlined"
            color="success"
            onClick={handleResetarSenha}
          >
            Sim
          </MDButton>
          <MDButton
            variant="outlined"
            color="error"
            onClick={() => setConfirmedReset(!confirmedReset)}
          >
            Não
          </MDButton>
        </MDBox>
      ) : (
        <MDBox
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
          width={{ xs: "100%", md: "24%" }}
        >
          <MDButton
            variant="outlined"
            color="error"
            onClick={() => setConfirmedReset(!confirmedReset)}
          >
            Resetar Senha
          </MDButton>
          {/* <Typography variant="caption" textAlign="center" color={colors.grey[500]}>
            Será enviado um nova senha no e-mail cadastrado
          </Typography> */}
        </MDBox>
      )}
    </>
  );
}
